import { render, staticRenderFns } from "./WhyChooseSection.vue?vue&type=template&id=47d4e14e&scoped=true"
import script from "./WhyChooseSection.vue?vue&type=script&lang=js"
export * from "./WhyChooseSection.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseSection.vue?vue&type=style&index=0&id=47d4e14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4e14e",
  null
  
)

export default component.exports